module.exports = __webpack_public_path__ + "img/motor.e6c72f17.png";